// extracted by mini-css-extract-plugin
export var margin_left = "Socials-module--margin_left---Hmic";